import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#2C2C2C] text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <h3 className="text-xl font-bold mb-4 font-poppins">Mayo Design</h3>
            <p className="text-sm font-poppins mb-2">मायो डिजाइन</p>
            <p className="text-gray-400 text-sm leading-relaxed">
              Professional interior design studio in Gurugram, specializing in complete home makeovers, bespoke furniture, and thoughtful space planning.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 font-poppins">Quick Links</h3>
            <ul className="space-y-2">
              <Link to="/about" className="text-gray-400 hover:text-white transition-colors text-sm block">
                About Us
              </Link>
              <Link to="/services" className="text-gray-400 hover:text-white transition-colors text-sm block">
                Services
              </Link>
              <Link to="/projects" className="text-gray-400 hover:text-white transition-colors text-sm block">
                Projects
              </Link>
              <Link to="/process" className="text-gray-400 hover:text-white transition-colors text-sm block">
                Our Process
              </Link>
              <Link to="/reviews" className="text-gray-400 hover:text-white transition-colors text-sm block">
                Reviews
              </Link>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4 font-poppins">Our Services</h3>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>Complete Home Makeovers</li>
              <li>Interior Design</li>
              <li>Bespoke Furniture</li>
              <li>Space Planning</li>
              <li>Office Interiors</li>
              <li>Turnkey Execution</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4 font-poppins">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start text-gray-400 text-sm">
                <MapPin className="w-4 h-4 mr-2 mt-1 flex-shrink-0" />
                <span>86, Sector 86 Rd, Sector 86, Meoka, Gurugram, Haryana 122505</span>
              </li>
              <li className="flex items-center text-gray-400 text-sm">
                <Phone className="w-4 h-4 mr-2" />
                <a href="tel:+919910837533" className="hover:text-white transition-colors">
                  +91 99108 37533
                </a>
              </li>
              <li className="flex items-center text-gray-400 text-sm">
                <Mail className="w-4 h-4 mr-2" />
                <a href="mailto:info@mayodesign.in" className="hover:text-white transition-colors">
                  info@mayodesign.in
                </a>
              </li>
            </ul>
            <div className="flex space-x-4 mt-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Mayo Design. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;